import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

import {Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {
        key: '$index', 
        label:  '序号'
    },
    {
        key: 'employeeCode', 
        label: '教师编号', 
        width: 150
    },
    {
        key: 'employeeName', 
        label: '教师姓名'
    },
    {
        key: 'sex', 
        label: '性别',
        render: (d) => {
            if (d === 1) {
                return '男';
            } else if (d === 2) {
                return '女';
            }
            return '';
        }
    },
    {
        key: 'orgName',
        label: '评价部门'
    },
    {
        key: 'orgXzName',
        label: '行政部门'
    },
    {
        key: 'title',
        label: '职称'
    },
    {
        key: 'authFlag', 
        label: '是否授权（当前学期）',
        render: (d) => {
            if (d) {
                return <Tag color="#87d068">已授权</Tag>
            } else {
                return <Tag>未授权</Tag>
            }
        },
        width: 100
    }
    
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    
    const params = [];
    for (var i in keywords) {
        params.push(`${i}=${keywords[i] || ''}`)
    }
    
    return fetch.get('teacher/teaching/quality/org/auth/queryEmployee?'+ params.join('&'))
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection = () => {
    return DataGrid.selections;
}

const insert = (ids, orgId) => {
    const p = {
        ids: ids,
        orgId: orgId
    }
    return fetch.post('teacher/teaching/quality/org/auth/insert', p)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    insert
}